














































	import Vue from 'vue';
	import Component from 'vue-class-component';

	import dateGrossesseService from '@/services/dateGrossesseService.ts';

	const Props = Vue.extend({
		props: {
			//date presume grossesse
			dpg: {
				type: String,
				default: ''
			},
			//pour impression
			impression: {
				type: Boolean,
				default: false
			}
		}
	});

/** The Subheader of the application */
@Component
	export default class CommonSubheader extends Props {

		dateGrossesseService = dateGrossesseService;

		//date debut prise en charge a 100% dd/MM/YYYY
		get dateDebutPec100() {
			//date presumee de grossesse + 5 mois
			if (this.dpg != '') {
				return dateGrossesseService.dateDecalee(this.dpg, 5, 0);
			}
			return '';
		}
		//date debut prise en charge a 100% dd/MM/YYYY
		get dateFinPec100() {
			//date presumee de grossesse + 9 mois + 12 jours
			if (this.dpg != '') {
				return dateGrossesseService.dateDecalee(this.dpg, 9, 12);
			}
			return '';
		}
	}
